export enum DownloadStatusesTypes {
  Authenticating = "Authenticating",
  CheckingCredits = "CheckingCredits",
  CompanyCardExpired = "CompanyCardExpired",
  CompanyCardInUse = "CompanyCardInUse",
  CreditReserved = "CreditReserved",
  DownloadingDriverData = "DownloadingDriverData",
  DownloadingVehicleData = "DownloadingVehicleData",
  InsufficientCredits = "InsufficientCredits",
  NoCompanyCards = "NoCompanyCards",
  NoSchedulesApplied = "NoSchedulesApplied",
  NoDueSchedules = "NoDueSchedules",
  ProcessTerminated = "ProcessTerminated",
  ReceivingDownloadList = "ReceivingDownloadList",
  ReceivingDriverInfo = "ReceivingDriverInfo",
  ReceivingDriversSchedules = "ReceivingDriversSchedules",
  ReceivingStatusState = "ReceivingStatusState",
  ReceivingVehicleSchedules = "ReceivingVehicleSchedules",
  StageComplete = "StageComplete",
  TerminatingConnectionToDevice = "TerminatingConnectionToDevice",
  UploadingDriverFiles = "UploadingDriverFiles",
  UploadingDriverFilesFailed = "UploadingDriverFilesFailed",
  UploadingVehicleFiles = "UploadingVehicleFiles",
  UploadingVehicleFilesFailed = "UploadingVehicleFilesFailed",
  VehicleDeactivated = "VehicleDeactivated",
  VuNotReady = "VuNotReady",
  WaitingForDeviceConnection = "WaitingForDeviceConnection"
}

export enum DownloadStagesTypes {
  DownloadTrigger = "DownloadTrigger",
  Initialization = "Initialization",
  Authentication = "Authentication",
  Downloading = "Downloading"
}

export enum SCHEDULE_CARDS_STATUSES {
  AwaitingConnection = "awaiting connection",
  Blocked = "blocked",
  Failed = "failed",
  InProgress = "in progress",
  Neutral = "neutral",
  RequirementNotMet = "requirement not met",
  Successful = "successful"
}

export enum ELIGIBILITY_CONDITIONS {
  CompanyCardActive = "CompanyCardActive",
  CreditsAvailable = "CreditsAvailable",
  ImeiAssigned = "ImeiAssigned",
  Ignition = "Ignition",
  ScheduleAssigned = "ScheduleAssigned",
  VehicleActive = "VehicleActive"
}

export enum CONDITION_FAILURE_REASONS {
  CompanyCardExpired = "CompanyCardExpired",
  IgnitionNotReportedRecently = "IgnitionNotReportedRecently",
  IgnitionOff = "IgnitionOff",
  InsufficientCredits = "InsufficientCredits",
  NoCompanyCardOnline = "NoCompanyCardOnline",
  NoCompanyCards = "NoCompanyCards",
  NoImeiAssigned = "NoImeiAssigned",
  NoScheduleAssigned = "NoScheduleAssigned",
  VehicleDeactivated = "VehicleDeactivated"
}

export enum SCHEDULE_TIMINGS {
  AwaitingConnection = "AwaitingConnection",
  Upcoming = "Upcoming",
  InProgress = "InProgress"
}

export enum REQUIREMENT_STATUS {
  Success = "success",
  Error = "error",
  Unknown = "unknown"
}
